import Icon from "@ant-design/icons";

const CompanyIconSVG = (props) => (
  <svg width="20" height={props?.height} viewBox="0 0 20 20" fill="none">
    <path
      d="M10.8334 18.9584H4.16675C2.15008 18.9584 1.04175 17.85 1.04175 15.8334V9.16669C1.04175 7.15002 2.15008 6.04169 4.16675 6.04169H8.33341C8.67508 6.04169 8.95841 6.32502 8.95841 6.66669V15.8334C8.95841 17.15 9.51675 17.7084 10.8334 17.7084C11.1751 17.7084 11.4584 17.9917 11.4584 18.3334C11.4584 18.675 11.1751 18.9584 10.8334 18.9584ZM4.16675 7.29169C2.85008 7.29169 2.29175 7.85002 2.29175 9.16669V15.8334C2.29175 17.15 2.85008 17.7084 4.16675 17.7084H8.16674C7.86674 17.2167 7.70841 16.5917 7.70841 15.8334V7.29169H4.16675Z"
      fill={props?.color}
    />
    <path
      d="M8.33341 7.29165H4.16675C3.82508 7.29165 3.54175 7.00831 3.54175 6.66665V4.99998C3.54175 3.73331 4.56675 2.70831 5.83341 2.70831H8.42507C8.61674 2.70831 8.80009 2.79996 8.91676 2.94996C9.03343 3.10829 9.07507 3.30831 9.02507 3.49165C8.97507 3.67498 8.95841 3.88331 8.95841 4.16665V6.66665C8.95841 7.00831 8.67508 7.29165 8.33341 7.29165ZM4.79175 6.04165H7.70841V4.16665C7.70841 4.09165 7.70841 4.02498 7.70841 3.95831H5.83341C5.25841 3.95831 4.79175 4.42498 4.79175 4.99998V6.04165Z"
      fill={props?.color}
    />
    <path
      d="M11.6667 11.4584C11.3251 11.4584 11.0417 11.175 11.0417 10.8334V6.66669C11.0417 6.32502 11.3251 6.04169 11.6667 6.04169C12.0084 6.04169 12.2917 6.32502 12.2917 6.66669V10.8334C12.2917 11.175 12.0084 11.4584 11.6667 11.4584Z"
      fill={props?.color}
    />
    <path
      d="M15 11.4584C14.6583 11.4584 14.375 11.175 14.375 10.8334V6.66669C14.375 6.32502 14.6583 6.04169 15 6.04169C15.3417 6.04169 15.625 6.32502 15.625 6.66669V10.8334C15.625 11.175 15.3417 11.4584 15 11.4584Z"
      fill={props?.color}
    />
    <path
      d="M15.0001 18.9584H11.6667C11.3251 18.9584 11.0417 18.675 11.0417 18.3334V15C11.0417 14.2 11.7001 13.5417 12.5001 13.5417H14.1667C14.9667 13.5417 15.6251 14.2 15.6251 15V18.3334C15.6251 18.675 15.3417 18.9584 15.0001 18.9584ZM12.2917 17.7084H14.3751V15C14.3751 14.8834 14.2834 14.7917 14.1667 14.7917H12.5001C12.3834 14.7917 12.2917 14.8834 12.2917 15V17.7084Z"
      fill={props?.color}
    />
    <path
      d="M5 14.7916C4.65833 14.7916 4.375 14.5083 4.375 14.1666V10.8333C4.375 10.4916 4.65833 10.2083 5 10.2083C5.34167 10.2083 5.625 10.4916 5.625 10.8333V14.1666C5.625 14.5083 5.34167 14.7916 5 14.7916Z"
      fill={props?.color}
    />
    <path
      d="M15.8333 18.9584H10.8333C8.81659 18.9584 7.70825 17.85 7.70825 15.8334V4.16669C7.70825 2.15002 8.81659 1.04169 10.8333 1.04169H15.8333C17.8499 1.04169 18.9583 2.15002 18.9583 4.16669V15.8334C18.9583 17.85 17.8499 18.9584 15.8333 18.9584ZM10.8333 2.29169C9.51659 2.29169 8.95825 2.85002 8.95825 4.16669V15.8334C8.95825 17.15 9.51659 17.7084 10.8333 17.7084H15.8333C17.1499 17.7084 17.7083 17.15 17.7083 15.8334V4.16669C17.7083 2.85002 17.1499 2.29169 15.8333 2.29169H10.8333Z"
      fill={props?.color}
    />
  </svg>
);
const CompanyIcon = (props) => (
  <Icon component={() => CompanyIconSVG(props)} {...props} />
);

export default CompanyIcon;
